module.exports = __webpack_public_path__ + "img/ru-ko.bc9ca30b.svg";